const stores = {
	yalo: 1,
	bancoInter: 2,
	bv: 3,
	theNail: 4,
	brasilAdm: 5,
	fidelidade: 6,
	marisa: 7,
	fretebras: 8,
	caarj: 9,
	altbank: 10,
	brasiladmvida: 11,
	brasiladmfidelidade: 12,
	brasiladmindividual: 13,
	emed: 14,
	epay: 15,
	vivoavulso: 16,
	cmDrConsulta: 17,
	qualiFamilia: 18,
	qualiMais: 19,
	drConsultaDrc: 20,
	drConsultaExame: 21,
	drConcultaTelemedicina: 22
};

export const redirectToStore = () => {
	const store = sessionStorage.getItem('store');

	switch (store) {
		case '1':
			window.location = '/loja/';
			break;
		case '2':
			window.location = '/loja/bancointer';
			break;
		case '3':
			window.location = '/loja/bv';
			break;
		case '4':
			window.location = '/loja/thenail';
			break;
		case '5':
			window.location = '/loja/brasiladm';
			break;
		case '6':
			window.location = '/loja/fidelidade';
			break;
		case '7':
			window.location = '/loja/marisa';
			break;
		case '8':
			window.location = '/loja/fretebras';
			break;
		case '15':
			window.location = '/loja/epay';
			break;
		case '16':
			window.location = '/loja/vivoavulso';
			break;
		case '17':
			window.location = '/loja/cmdrconsulta';
			break;
		case '18':
			window.location = `https://parcerias.qualicorp.com.br/qualifamilia`;
			break;
		case '19':
			window.location = `https://parcerias.qualicorp.com.br/drconsulta`;
			break;
		case '20':
			window.location = `https://yalo.com.br/familiadrc/`;
			break;
		case '21':
			window.location = `https://yalo.com.br/familiadrcexame/`;
			break;
		case '22':
			window.location = `https://yalo.com.br/familiadrctelemedicina/`;
			break;
		default:
			break;
	}
};

export const storesRel = [
	{ name: 'yalo', id: 1 },
	{ name: 'bancoInter', id: 2 },
	{ name: 'bv', id: 3 },
	{ name: 'theNail', id: 4 },
	{ name: 'brasilAdm', id: 5 },
	{ name: 'fidelidade', id: 6 },
	{ name: 'marisa', id: 7 },
	{ name: 'fretebras', id: 8 },
	{ name: 'caarj', id: 9 },
	{ name: 'altbank', id: 10 },
	{ name: 'brasiladmvida', id: 11 },
	{ name: 'brasiladmfidelidade', id: 12 },
	{ name: 'brasiladmindividual', id: 13 },
	{ name: 'emed', id: 14 },
	{ name: 'epay', id: 15 },
	{ name: 'vivoavulso', id: 16 },
	{ name: 'cmdrconsulta', id: 17 },
	{ name: 'qualicorp', id: 18 },
	{ name: 'qualicorp', id: 19 },
	{ name: 'drconsulta', id: 20 },
	{ name: 'drconsulta', id: 21 },
	{ name: 'drconsulta', id: 22 }
];

export default stores;
